import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ecd15b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb-wrapper" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "breadcrumb-list" }
const _hoisted_4 = {
  key: 0,
  class: "breadcrumb-text"
}
const _hoisted_5 = { class: "breadcrumb-input" }
const _hoisted_6 = { class: "dummy" }
const _hoisted_7 = ["onUpdate:modelValue", "onChange"]
const _hoisted_8 = {
  key: 3,
  class: "breadcrumb-select"
}
const _hoisted_9 = ["onUpdate:modelValue", "onChange"]
const _hoisted_10 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            class: "item"
          }, [
            (item.type === 'text')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (item.text.name)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.text.name) + " " + _toDisplayString(item.text.secondName), 1))
                    : _createCommentVNode("", true)
                ], 64))
              : (item.type === 'link')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (item.link.name)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: item.link.path,
                          class: _normalizeClass(["breadcrumb-text", { '-strong': item.size === 'large' }])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.link.name) + " " + _toDisplayString(item.link.secondName), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (item.type === 'input')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (item.input.name)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: _normalizeClass(["breadcrumb-text", { '-strong': item.size === 'large' }])
                          }, _toDisplayString(item.input.name), 3))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.input.inputName), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "input",
                          "onUpdate:modelValue": ($event: any) => ((item.input.inputName) = $event),
                          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.inputBeforeChangeValue && _ctx.inputBeforeChangeValue(...args))),
                          onChange: ($event: any) => (_ctx.onChangeInput($event, index))
                        }, null, 40, _hoisted_7), [
                          [_vModelText, item.input.inputName]
                        ])
                      ])
                    ], 64))
                  : (item.type === 'select')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("select", {
                          class: "select",
                          "onUpdate:modelValue": ($event: any) => ((item.select.currentId) = $event),
                          onChange: ($event: any) => (_ctx.onChangeSelect(index, item.select.type))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.select.list, (select) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: select.id,
                              value: select.id
                            }, _toDisplayString(select.name), 9, _hoisted_10))
                          }), 128))
                        ], 40, _hoisted_9), [
                          [_vModelSelect, item.select.currentId]
                        ])
                      ]))
                    : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}